var _defs, _path, _tspan, _tspan2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEntwickeltFuerInventoIcpUndIcs = function SvgEntwickeltFuerInventoIcpUndIcs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Entwickelt_fuer_Invento_ICP_und_ICS_svg__Ebene_2",
    viewBox: "0 0 100.61 87.13"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Entwickelt_fuer_Invento_ICP_und_ICS_svg__clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.94 85.76 1.58 43.56 25.94 1.37h48.72l24.37 42.19-24.37 42.2z",
    className: "Entwickelt_fuer_Invento_ICP_und_ICS_svg__cls-2"
  })), /*#__PURE__*/React.createElement("style", null, ".Entwickelt_fuer_Invento_ICP_und_ICS_svg__cls-2{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2.74px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Entwickelt_fuer_Invento_ICP_und_ICS_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#Entwickelt_fuer_Invento_ICP_und_ICS_svg__clippath)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m73.14 4 22.84 39.56-22.84 39.56H27.46L4.62 43.56 27.46 4zm1.52-2.63H25.94L1.58 43.56l24.36 42.19h48.72l24.36-42.19z",
    style: {
      fill: "none"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.94 85.76 1.58 43.56 25.94 1.37h48.72l24.37 42.19-24.37 42.2z",
    className: "Entwickelt_fuer_Invento_ICP_und_ICS_svg__cls-2"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "currentColor",
      fontFamily: "ProximaNova-Medium,&quot",
      fontSize: "32.3px",
      fontWeight: 500
    },
    transform: "translate(26.3 38.79)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ICP")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 30.64
  }, "ICS")))));
};
export default SvgEntwickeltFuerInventoIcpUndIcs;